import { FormattedMessage } from 'react-intl'
import { FormInput } from '../forms/final-form-fields'

export default function Sepa({ buttonText, errorsRef }) {
  return (
    <div className='payment-methods-list__inner'>
      <div className='payment-block text-left clearfix'>
        <form name='ibanForm'>
          <p className='title'>
            <FormattedMessage
              id='bank_acc_details'
              defaultMessage='Bank Account details'
            />
          </p>
          <div className='double'>
            <div className='form-group'>
              <FormInput
                name='ibanName'
                isRequired
                label={<FormattedMessage id='name' defaultMessage='Name' />}
              />
            </div>
            <div className='form-group'>
              <FormInput
                name='ibanEmail'
                isRequired
                label={
                  <FormattedMessage
                    id='email_address'
                    defaultMessage='Email Address'
                  />
                }
              />
            </div>
          </div>
          <div className='form-group new-section'>
            <label>
              <FormattedMessage id='IBAN' defaultMessage='IBAN' />
              <span className='asterisk'>*</span>
            </label>
            <div id='iban-element' />
            <span id='bank-name' />
          </div>
          <div className='error-msg stripe-errors' ref={errorsRef} />
        </form>
      </div>
      <div className='payment-submit'>
        <button className='btn-red'>
          {buttonText || (
            <FormattedMessage id='submit' defaultMessage='Submit' />
          )}
        </button>
        <div className='payment-hint'>
          <FormattedMessage
            id='sepa_hint'
            defaultMessage='By providing your IBAN and confirming this payment, you are authorizing Padi Inc. and Stripe, our payment service provider, to send instructions to your bank to debit your account and your bank to debit your account in accordance with those instructions. You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited.'
          />
        </div>
      </div>
    </div>
  )
}
